import React from "react";
import { GiCompass, GiDiamondHard, GiStabbedNote } from "react-icons/gi";
export const links = [
  {
    id: 1,
    text: "home",
    url: "/",
  },
  {
    id: 2,
    text: "about",
    url: "/about",
  },
  {
    id: 3,
    text: "products",
    url: "/products",
  },
];

export const services = [
  {
    id: 1,
    icon: <GiCompass />,
    title: "mission",
    text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptates, ea. Perferendis corrupti reiciendis nesciunt rerum velit autem unde numquam nisi",
  },
  {
    id: 2,
    icon: <GiDiamondHard />,
    title: "vision",
    text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptates, ea. Perferendis corrupti reiciendis nesciunt rerum velit autem unde numquam nisi",
  },
  {
    id: 3,
    icon: <GiStabbedNote />,
    title: "history",
    text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptates, ea. Perferendis corrupti reiciendis nesciunt rerum velit autem unde numquam nisi",
  },
];

export const images = [
  {
    url: "https://images2.imgbox.com/da/bb/iXlbK9A6_o.jpeg",
  },
  { url: "https://images2.imgbox.com/6d/47/A11k7xmf_o.jpeg" },
  { url: "https://images2.imgbox.com/ca/f3/rPR1K8nP_o.jpeg" },
  { url: "https://images2.imgbox.com/1b/ea/t89LageS_o.jpeg" },
];

export const products_url = "https://e-commerce-server-nr8x.onrender.com/products";

// const single_product_url = `https://course-api.com/react-store-single-product?id=`;
